const MeasureUnitEnum = {
  KG: "KG",
  TONN: "TONN",
  STK: "STK",
  M3: "M3",
  METER: "METER",
} as const;

export default MeasureUnitEnum;
